// extracted by mini-css-extract-plugin
module.exports = {"detail":"btActRule_detail_2jtcb","box":"btActRule_box_HZmt2","title":"btActRule_title_1Yhbi","time":"btActRule_time_2HcXO","content":"btActRule_content_2ckFw"};